import { render, staticRenderFns } from "./Nfc.vue?vue&type=template&id=5c43388d&"
import script from "./Nfc.vue?vue&type=script&lang=js&"
export * from "./Nfc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports